export enum DataFileType {
  Automated = 'Automated',
  Emailed = 'Emailed',
  SFTP = 'SFTP',
  Uploaded = 'Uploaded',
}
